export const meta: BlockMeta = {
  title: "Info Slider",
  description: "",
  keywords: ["Info Slider"],
  // @ts-ignore
  icon: "images-alt2",
  cache: false,
  tags: ["root"],
  conditions: {
    multiple: true,
  },
}

import { useInView } from "@hooks/useInView"
import { ButtonThemeTypes } from "@utils/tw"
import { defineBlock, InnerBlocks, useInnerBlocks } from "eddev/blocks"
import { useEffect, useRef, useState } from "react"
import { Swiper, SwiperSlide } from "@components/atoms/Swiper"

export default defineBlock("content/info-slider", () => {
  const { ref } = useInView()
  const swiperRef = useRef<any>(null)

  const innerBlocks = useInnerBlocks()
  const slides = innerBlocks.filter((block) => block.slug === "content/info-slide").map((block) => block)
  const themes = slides.map((slide) => slide.props.blockTheme! as ButtonThemeTypes)

  useEffect(() => {
    if (!swiperRef.current) return

    const swiper = swiperRef.current.firstChild?.swiper
    if (!swiper) return

    const color = getComputedStyle(document.documentElement)
      .getPropertyValue(`--color-${themes[swiper.realIndex]}-1`)
      .replaceAll(" ", ",")
    document.documentElement.style.setProperty("--color-highlights", `rgb(${color})`)

    swiper.on("slideChange", () => {
      const color = getComputedStyle(document.documentElement)
        .getPropertyValue(`--color-${themes[swiper.realIndex]}-1`)
        .replaceAll(" ", ",")
      document.documentElement.style.setProperty("--color-highlights", `rgb(${color})`)
    })
  }, [swiperRef.current])

  const warmBlack = `37,38,43`

  return (
    <div className="w-full overflow-hidden">
      <div className="grid-auto relative mb-9 px-4 bg-cardboard text-warmblack" ref={ref}>
        <div className={`col-span-12 pb-9`}>
          <div className="w-full md:hidden">
            <Swiper
              a11y={{
                enabled: true,
              }}
              spaceBetween={16}
              keyboard={{
                enabled: true,
              }}
              loop={false}
              autoplay={{
                delay: 8000,
              }}
              navigation
              pagination={{
                type: "bullets",
              }}
              speed={600}
              slidesPerView={1}
              centeredSlides
              injectStyles={[swiperClasses(warmBlack)]}
            >
              <InnerBlocks
                allowedBlocks={["content/info-slide"]}
                appender={{
                  type: "button",
                }}
                //@ts-ignore
                wrapBlock={(child) => <SwiperSlide class="swiper-slide h-auto">{child}</SwiperSlide>}
              />
            </Swiper>
          </div>
          <div ref={swiperRef} className="w-full hidden md:block">
            <Swiper
              a11y={{
                enabled: true,
              }}
              spaceBetween={16}
              keyboard={{
                enabled: true,
              }}
              loop={false}
              autoplay={{
                delay: 5000,
              }}
              navigation
              pagination={{
                type: "bullets",
              }}
              effect="fade"
              fadeEffect={{
                crossFade: true,
              }}
              speed={600}
              slidesPerView={1}
              centeredSlides
              injectStyles={[swiperClasses(warmBlack)]}
            >
              <InnerBlocks
                allowedBlocks={["content/info-slide"]}
                appender={{
                  type: "button",
                }}
                //@ts-ignore
                wrapBlock={(child) => <SwiperSlide class="swiper-slide h-auto">{child}</SwiperSlide>}
              />
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  )
})

const swiperClasses = (warmBlack: string) => `
                .swiper {
                  overflow: visible;
                }

                .swiper-pagination {
                  position: absolute;
                  top: 100%;
                  bottom: auto !important;
                  height: 28px;
                  align-items: center;
                  padding: calc(var(--spacing-8)) 0;
                  display: flex;
                  gap: 14px;
                  width: auto !important;
                  z-index: 10;

                  .swiper-pagination-bullet {
                    width: 5px;
                    height: 5px;

                    &.swiper-pagination-bullet-active {
                      background: rgb(${warmBlack}) !important;
                    }
                  }
                }

                .swiper-button-prev,
                .swiper-button-next {
                  top: 100% !important;
                  bottom: auto !important;
                  margin: calc(var(--spacing-8)) 0 0;
                  width: 28px;
                  height: 28px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border: 1px solid rgb(${warmBlack});
                  border-radius: 8px;
                  color: rgb(${warmBlack});
                  z-index: 20;
                  left: auto !important;
                  
                  svg {
                    width: 7px !important;
                    height: 7px !important;

                    path {
                      stroke: rgb(${warmBlack});
                      stroke-width: 3px;
                    }
                  }
                }

                .swiper-button-prev {
                  right: 40px !important;
                }

                .swiper-button-next {
                  right: 0 !important;
                }

                @media only screen and (min-width: 900px) {
                  .swiper-pagination {
                    top: auto !important;
                    bottom: var(--spacing-4) !important;
                    left: calc(50% + var(--spacing-4)) !important;
                    padding: 0;

                    .swiper-pagination-bullet {
                      width: 5px;
                      height: 5px;
                      background: var(--color-highlights) !important;

                      &.swiper-pagination-bullet-active {
                        background: var(--color-highlights) !important;
                      }
                    }
                  }

                  .swiper-button-prev,
                  .swiper-button-next {
                    top: auto !important;
                    bottom: var(--spacing-4) !important;
                    border: 1px solid var(--color-highlights);

                    svg {
                      path {
                        stroke: var(--color-highlights);
                      }
                  }
                  }

                  .swiper-button-prev {
                    right: calc(40px + var(--spacing-4)) !important;
                  }

                  .swiper-button-next {
                    right: var(--spacing-4) !important;
                  }
                }
              `
